'use strict';
import Env from '../base/env.js';
import Channels from '../base/channels'
import Barba from 'barba.js';
import Timeline from '../components/Timeline'
import PlayerSimple from '../components/PlayerSimple'
import FlowWaypoints from '../fx/FlowWaypoints'
import Logo from '../components/home/Logo'
import Mailto from '../components/Mailto'

let page

class Page
{
    constructor(view='')
    {
        this.view = view
        this.classView = 'currentView--home'
        // Objects
        this.player = false
        // States
        this.timeoutLogoUi = (Env.isVisiting)?200:0
        // Fns
        new Mailto(this.view)
        if(this.view.querySelector('.jsTimeline--view')) {
            this.timeline = new Timeline(this.view.querySelector('.jsTimeline--view'))
            this.timeline.setup()
        }
        if(Env.mobileCSS == false) {
            this.logoUI = new Logo(this.view)
            this.logoUI.setup()
        }
        // Launch Fn
        this.funcLaunch = this.intro.bind(this)
        if(Env.framework.UI.launcher.LAUNCHED == false) this.channels()
    }

    channels()
    {
        Channels.on('launcher::exit',this.funcLaunch)
    }

    destroy()
    {
        if(typeof this.timeline != 'undefined') {
            this.timeline.destroy()
        }
        if(typeof this.player != 'undefined') {
            this.player.destroy()
        }
        if(typeof this.logoUI != 'undefined') {
            this.logoUI.destroy()
        }
        this.waypoints.destroy()
        Channels.removeListener('launcher::exit', this.funcLaunch);
    }

    finalize()
    {
        setTimeout(() => {
            if(Env.isVisiting === true) {
                this.intro()
            }
            this.waypoints = new FlowWaypoints(this.view)
        }, 200);
        setTimeout(() => {
            Env.$html.classList.add('ui--logoHidden')
        }, this.timeoutLogoUi);
        this.player = new PlayerSimple(this.view)
        if(typeof this.logoUI != 'undefined') {
            this.logoUI.start()
        }
    }

    intro()
    {
        const tl = new TimelineLite()
        const $itemsTimeline = this.view.querySelectorAll('.jsTimeline--view .jsItem .jsLink .bg')
        const $itemsTimelineDesc = this.view.querySelectorAll('.jsTimeline--view .jsItem .description')
        const $homeBrand = this.view.querySelectorAll('.home-brand')
        const $progression = this.view.querySelector('.timeline__progression')
        const $logoSticky = this.view.querySelector('.jsLogo--sticky')

        if(Env.mobileCSS == true) {
            tl.add([
                TweenMax.staggerFromTo($itemsTimeline , 1 , { opacity : 0 , x : '0' } , { opacity : 1 , x : '0%' , ease : Power4.easeOut },.03),
                TweenMax.staggerFromTo($itemsTimelineDesc , 1 , { opacity : 0 } , { opacity : 1 , ease : Cubic.easeOut },.03),
                TweenMax.fromTo($homeBrand , 1 , { opacity : 0 } , { opacity : 1 , ease : Cubic.easeOut }),
            ])
        } else {
            tl.add([
                TweenMax.staggerFromTo($itemsTimeline , 1 , { opacity : 0 , x : '-105%' } , { opacity : 1 , x : '0%' , ease : Power4.easeOut },.03),
                TweenLite.fromTo($progression , .8 , { opacity : 0 , y : 50 } , { opacity : 1 , y : 0 , ease : Cubic.easeOut , delay : .2 }),
                TweenLite.fromTo($logoSticky , .8 , { opacity : 0 } , { opacity : 1, ease : Cubic.easeOut , delay : .4 }),
            ])
        }

        tl.add(()=>{
            this.timeline.startAutoscroll()
        })
    }


}

page = Barba.BaseView.extend({
    namespace: 'home',
    node: undefined,
    onEnter: function() {
        this.node = new Page(this.container)
        Env.$html.classList.add(this.node.classView)
    },
    onEnterCompleted:function()
    {
        this.node.finalize()
    },
    onLeave: function()
    {
        this.node.destroy()
    },
    onLeaveCompleted: function()
    {
        if(this.container.getAttribute('data-namespace') != this.namespace)
        {
            Env.$html.classList.remove(this.node.classView)
        }
        Env.$html.classList.remove('ui--logoHidden')
    }
});

export default page;


// WEBPACK FOOTER //
// ./resources/js/view/home.js